'use client'

import React from 'react'

import { GyymApiContext } from '../providers'

export const useGyymClient = () => {
  return React.useContext(GyymApiContext)
}
